import Api from "../../api/index";

const Department = {
  namespaced: true,
  state: {
    all_departments: [],
    one_department: {},

    all_employees: [],
    one_employee: {},

    all_forms: [],
    one_form: {}
  },
  getters: {
    getOneDepartmentId: (state) => {
      return state.one_department.id;
    },
    deptSearch: (state, getters) => (element, id) => {
      if (element.id == id) {
        return element;
      } else if (element.children != null) {
        let i;
        let result = null;
        for(i=0; result == null && i < element.children.length; i++) {
          result = getters.deptSearch(element.children[i], id);
        }
        return result;
      }
      return null;
    }
  },
  mutations: {
    setAllEmployees(state, employees) {
      state.all_employees = [...employees.map((emp) => emp.attributes)];
    },
    setOneEmployee(state, employee) {
      state.one_employee = {...employee};
    },
    setAllDepartments(state, departments) {
      state.all_departments = !departments[0][0].ancestry
                       ? [...departments[0][0].children]
                       : [...departments.map(d => d[0])];
    },
    clearAllEmployees(state) {
      state.all_employees = [];
    },
    setOneDepartment(state, department) {
      state.one_department = {...department};
    },
    clearOneDepartment(state) {
      state.one_department = {};
    },
    clearOneEmployee(state) {
      state.one_employee = {};
    },
    userCreated(state, user) {
      console.log("user => ", user);
      let employee = {
        id: user.employee.id,
        name: user.name,
        email: user.email,
        user_id: user.id,
        company_id: user.employee.company_id,
        department_ids: user.department_ids,
        register: user.employee.register,
        role_ids: user.roles.map((role) => role.id),
        user_role: user.roles[0].translated
      }

      state.all_employees.unshift(employee);
    },
    userUpdated(state, user) {
      let employee = {
        id: user.employee.id,
        name: user.name,
        email: user.email,
        user_id: user.id,
        company_id: user.employee.company_id,
        department_ids: user.department_ids,
        register: user.employee.register,
        role_ids: user.roles.map((role) => role.id),
        user_role: user.roles[0].translated
      }

      let idx = state.all_employees.findIndex((emp) => emp.id == employee.id);

      state.all_employees.splice(idx, 1, {...employee});
    },
    userDeleted(state, user) {
      let idx = state.all_employees.findIndex((emp) => emp.user_id == user.id);

      state.all_employees.splice(idx, 1);
    },
    userRestored(state, user) {
      let idx = state.all_employees.findIndex((emp) => emp.user_id == user.id);

      state.all_employees.splice(idx, 1);
    },
    userDeactivated(state, user) {
      let idx = state.all_employees.findIndex((emp) => emp.user_id == user.id);

      state.all_employees.splice(idx, 1);
    }
  },
  actions: {
    indexDepartments({commit}, filter) {
      return Api.Department.index(filter).then((r) => r.data).then((deps) => {
        commit("setAllDepartments", deps);
        return deps;
      }).catch((error) => {
        console.log(error);
      });
    },
    updateDepartment({commit, dispatch}, department) {
      let notification = {};
      return Api.Department.update(department).then((r) => r.data).then((r) => {
        notification.type = "success";
        notification.msg = "Feito com sucesso";
        return r;
      }).catch((error) => {
        notification.type = "error";
        notification.msg = `Erro: ${error}`;
      }).finally(() => {
        dispatch("Notification/add", notification, {root: true});
      })
    },
    deleteDepartment({commit, dispatch}, department) {
      let notification = {};
      return Api.Department.delete(department).then((r) => r.data).then((r) => {
        notification.type = "success";
        notification.msg = "Feito com sucesso";
        return r;
      }).catch((error) => {
        notification.type = "error";
        notification.msg = `Erro: ${error}`;
      }).finally(() => {
        dispatch("Notification/add", notification, { root: true });
      })
    },
    departmentAssociations({commit, dispatch, state}, {department_id, solution_id}) {
      let notification = {};

      return Api.Department.associations(department_id, solution_id).then((r) => r.data).then((r) => {
        return r;
      }).catch((error) => {
        notification.type = "error";
        notification.msg = `Erro: ${error}`;
      }).finally(() => {
        if (notification && notification.type) {
          dispatch("Notification/add", notification, {root: true});
        }
      });
    },
    moveAssociations({commit, dispatch}, department) {
      let notification = {};

      return Api.Department.moveAssociations(department).then((r) => r.data).then((r) => {
        notification.type = "success";
        notification.msg = "Feito com sucesso";
      }).catch((error) => {
        notification.type = "error";
        notification.msg = `Erro: ${error}`;
      }).finally(() => {
        dispatch("Notification/add", notification, {root: true});
      })
    },
    indexEmployees({commit}, filter) {
      return Api.Employee.index(filter).then((r) => r.data).then((employees) => {
        commit("setAllEmployees", employees.data.data);
        return employees;
      }).catch((error) => {
        console.log(error);
      })
    },
    indexNewUsers({commit}) {
      return Api.Employee.getNewUsers().then((r) => r.data).then((employees) => {
        commit("setAllEmployees", employees.data);
        return employees;
      }).catch((error) => {
        console.log(error);
      })
    },
    createEmployee({commit, dispatch, rootState}, user) {
      let notification = {};

      user.employee_attributes.company_id = rootState.User.oneUser.company.data.attributes.id;

      return Api.User.create(user).then((r) => r.data).then((r) => {
        commit("userCreated", r.data.attributes);
        notification.type = "success";
        notification.msg = "Feito com sucesso";
        return r.data;
      }).catch((error) => {
        notification.type = "error";
        notification.msg = error;
        if (error.response) {
          if (error.response.data) {
            if (error.response.data.company) {
              notification.msg = error.response.data.company[0]
            } else if (error.response.data.email) {
              notification.msg = error.response.data.user[0]
            }
          }
        }
      }).finally(() => {
        dispatch("Notification/add", notification, {root: true});
      })
    },
    updateEmployee({state, commit, dispatch}, user) {
      let notification = {};

      return Api.User.update(user).then((r) => r.data).then((r) => {
        commit("userUpdated", r.data.attributes);
        notification.type = "success";
        notification.msg = "Feito com sucesso";
        return r;
      }).catch((error) => {
        notification.type = "error";
        notification.msg = error;
      }).finally(() => {
        dispatch("Notification/add", notification, {root: true});
      })
    },
    deleteEmployee({commit, dispatch}, user) {
      let notification = {};

      return Api.User.delete(user).then((r) => r.data).then((r) => {
        commit("userDeleted", r);
        notification.type = "success";
        notification.msg = "Feito com sucesso";
        return r;
      }).catch((error) => {
        notification.type = "error";
        notification.msg = error;
      }).finally(() => {
        dispatch("Notification/add", notification, {root: true});
      });
    },
    restoreEmployee({state, commit, dispatch}, user) {
      let notification = {};

      return Api.User.restore(user).then((r) => r.data).then((r) => {
        commit("userRestored", r.data.attributes);
        notification.type = "success";
        notification.msg = "Feito com sucesso";
        return r.data.attributes;
      }).catch((error) => {
        notification.type = "error";
        notification.msg = error;
      }).finally(() => {
        dispatch("Notification/add", notification, {root: true});
      })
    },
    reactivateEmployee({state, commit, dispatch}, user) {
      let notification = {};

      return Api.User.reactivate(user).then((r) => r.data).then((r) => {
        commit("userRestored", r.data.attributes);
        notification.type = "success";
        notification.msg = "Feito com sucesso";
        return r.data.attributes;
      }).catch((error) => {
        notification.type = "error";
        notification.msg = error;
      }).finally(() => {
        dispatch("Notification/add", notification, {root: true});
      })
    },
    deactivateEmployee({state, commit, dispatch}, user) {
      let notification = {};

      return Api.User.deactivate(user).then((r) => r.data).then((r) => {
        commit("userDeactivated", r.data.attributes);
        notification.type = "success";
        notification.msg = "Feito com sucesso";
        return r.data.attributes;
      }).catch((error) => {
        notification.type = "error";
        notification.msg = error;
      }).finally(() => {
        dispatch("Notification/add", notification, {root: true});
      })
    },
  }
};

export default Department;